import { Component, input, output, ChangeDetectionStrategy } from '@angular/core';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { faWarning } from '@fortawesome/pro-duotone-svg-icons';
import { TranslatePipe } from '@ngx-translate/core';

@Component({
  selector: 'andor-media-access-denied',
  standalone: true,
  imports: [FontAwesomeModule, TranslatePipe],
  templateUrl: './media-access-denied.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  styleUrl: './media-access-denied.scss',
})
export class MediaAccessDenied {
  icon = input(faWarning);
  text = input('');
  onShowTutorial = output();
}
